import { ReactElement, cloneElement } from 'react';
import classNames from 'classnames';

export interface HeaderPrimaryItemProps {
  children: ReactElement;
  /**
   * Set to true to indicate current section
   *
   */
  current?: boolean;
}

const HeaderPrimaryItem = ({ children, current }: HeaderPrimaryItemProps): JSX.Element => {
  const headerItemClasses = classNames({
    'usa-nav__link': true,
    'usa-current': current,
  });

  return cloneElement(children, { className: headerItemClasses });
};

export default HeaderPrimaryItem;
